import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/financial',
  component: getView('pages/PageDosing'),
  name: 'financial',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'ANALYTICS - Financial',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-dosing',
  },
};
